import { supabase } from '../supabaseClient';

async function getSpecificEvents(loggedInUserId) {
    const { data, error, count } = await supabase.rpc('getongoingeventsbyuserid', { pid: loggedInUserId }, { count: 'exact' }).order('eventname', { ascending: false });
    if (data) return { data, count };
    else throw error;
}
//to show in more button
async function getAllotedData(leadId) {
    const { data, count, error } = await supabase.from('AllotmentPayment')
        .select('*,inventoryMergedId(*,projectId(*),unit1Id(*,wingId(*)),unit2Id(*,wingId(*))),unitId(*,projectId!left(*),wingId(*)),CRM!left(*) , CancelUnitRequests!left(*)', { count: 'exact' })
        .order('last_updated_at', { ascending: false })
        .eq('leadId', leadId);
    if (data) return { data, count };
    else throw error;
}

async function getFirstPaymentDate(allotmentPaymentId) {
    const { data, count, error } = await supabase.from('AllotmentTransactions')
        .select('*', { count: 'exact' })
        .order('last_updated_at', { ascending: true })
        .limit(1)
        .eq('allotmentPaymentId', allotmentPaymentId);
    if (data) return { data, count };
    else throw error;
}



async function getAllotedDataInChangeUnit(leadId) {
    const { data, count, error } = await supabase.from('AllotmentPayment')
        .select('*,inventoryMergedId(*,projectId(*),unit1Id(*,wingId(*)),unit2Id(*,wingId(*))),unitId(*,projectId!left(*),wingId(*)),CRM!left(*),paymentId(*,eventTokenId(*))', { count: 'exact' })
        .order('last_updated_at', { ascending: false })
        .in('status', ['Preselected', 'Payment Pending', 'Partial Payment Done', 'Payment Complete', 'On Hold'])
        .eq('leadId', leadId)
    if (data) return { data, count };
    else throw error;
}
async function getAllotedDataInAlotExistingUnit(leadId) {
    const { data, count, error } = await supabase.from('AllotmentPayment')
        .select('*,inventoryMergedId(*,projectId(*),unit1Id(*,wingId(*)),unit2Id(*,wingId(*))),unitId(*,projectId!left(*),wingId(*))', { count: 'exact' })
        .order('last_updated_at', { ascending: false })
        .in('status', ['Preselected', 'Payment Pending', 'Partial Payment Done', 'Payment Complete'])
        .eq('leadId', leadId)
    if (data) return { data, count };
    else throw error;
}
async function getDataFromInventory(projectId, wingId, inventoryTypeId, unitId) {
    const { data, count, error } = await supabase.from('Inventory')
        .select('*', { count: 'exact' })
        .order('last_updated_at', { ascending: false })
        .eq('inventoryTypeId', inventoryTypeId)
        .eq('projectId', projectId)
        .eq('wingId', wingId)
        .eq('unitId', unitId)
    if (data) return { data, count };
    else throw error;
}

//change Unit
async function changeAllotedUnit(userId, allotmentPaymentId, reason, status, requestedUnitId, requestPendingWithId, newBookingAmount, oldBookingAmount, oldUnit, oldStatus, leadStatus, unitPriceAlreadyUpdated, oldPaymentPlanId, newPaymentPlanId) {
    const { data, error } =
        await supabase.from('ChangeUnitRequests').insert([
            {
                userId: userId,
                lastUpdatedBy: userId,
                allotmentPaymentId: allotmentPaymentId,
                reason: reason,
                status: status,
                leadConfirmation: 'Accepted',
                requestedUnitId: requestedUnitId,
                requestPendingWithUserId: requestPendingWithId,
                newBookingAmount: newBookingAmount,
                oldBookingAmount: oldBookingAmount,
                currentUnitId: oldUnit,
                allotmentStatus: oldStatus,
                leadStatus: leadStatus,
                unitPriceAlreadyUpdated: unitPriceAlreadyUpdated,
                oldPaymentPlanId: oldPaymentPlanId,
                newPaymentPlanId: newPaymentPlanId,
            }])
    if (data) return data;
    else throw error;
}

// Is a Change Unit request already sitting at 'Pending' for THIS allotment?
//
// One pending request per allotment is the rule updateChangeUnit() already enforces
// at write time; this is the same question asked up front so the UI can say so.
// Filters ChangeUnitRequests.allotmentPaymentId directly -- no embed, so no
// `allotmentPaymentId !== null` post-filter of the kind checkForChangeUnitStatus
// below needs.
async function getPendingChangeUnitRequestsByAllotment(allotmentPaymentId) {
    const { data, error } = await supabase.from('ChangeUnitRequests')
        .select('changeUnitRequestId,status,allotmentPaymentId')
        .eq('status', 'Pending')
        .eq('allotmentPaymentId', allotmentPaymentId);
    if (data) return data;
    else throw error;
}

//get changeRequest
async function checkForChangeUnitStatus(unitId, inventoryMergedId, allotmentPaymentId) {
    var query;
    query = supabase.from('ChangeUnitRequests')
        .select('*,allotmentPaymentId!left(*)', { count: 'exact' })
        .order('last_updated_at', { ascending: false })
    if (inventoryMergedId === null || inventoryMergedId === undefined) {
        query = query.eq('allotmentPaymentId.unitId', unitId);
    } else {
        query = query.eq('allotmentPaymentId.inventoryMergedId', inventoryMergedId);

    }
    query = query.eq('allotmentPaymentId.allotmentPaymentId', allotmentPaymentId);
    query = query.eq('status', 'Pending');
    const { data, count, error } = await query
    if (data) return { data, count };
}
//check for cancel request

async function checkForCancelUnitRequest(unitId, inventoryMergedId) {
    var query;
    query = supabase.from('CancelUnitRequests')
        .select('*,allotmentPaymentId!left(*)', { count: 'exact' })
        .order('last_updated_at', { ascending: false })
    if (inventoryMergedId === null || inventoryMergedId === undefined) {
        query = query.eq('allotmentPaymentId.unitId', unitId);
    } else {
        query = query.eq('allotmentPaymentId.inventoryMergedId', inventoryMergedId);

    }
    const { data, count, error } = await query
    if (data) return { data, count };
}
//chancelAlotRequest
async function cancelAllotedUnit(userId, allotmentPaymentId, reason, status, requestedUnitId, requestPending, leadId, leadConfirmation, oldLeadStatus, cancellationCharge, waveOff, obj, deemedCancellationId = null) {
    const { data, error } =
        await supabase.from('CancelUnitRequests').insert([
            {
                userId: userId,
                allotmentPaymentId: allotmentPaymentId,
                reason: reason,
                status: status,
                requestPendingWithUserId: requestPending.parentId,
                requestPendingWithRoleId: requestPending.roleId,
                leadId: leadId,
                leadConfirmation: leadConfirmation,
                oldLeadStatus: oldLeadStatus,
                cancellationCharges: cancellationCharge,
                isWaivedOff: waveOff,
                waivedOffReason: obj?.waivedOffReason,
                waivedOffCancellationCharges: obj?.waivedOffCancellationCharges,
                newCancellationCharges: obj?.newCancellationCharges,
                deemedCancellationId: deemedCancellationId // links back to DeemedCancellation record — null for genuine cancellation callers
            }])
    if (data) return data;
    else throw error;
}

// Allotment payment status
async function updateAllotmentPaymentStatus(allotmentPaymentId, status, unitCost) {
    const { data, error, count } = await supabase
        .from('AllotmentPayment')
        .update({ status: status, last_updated_at: new Date().getTime(), unitCost: unitCost })
        .eq('allotmentPaymentId', allotmentPaymentId)
    if (data) return { data, count };
    else throw error;
}

async function getAllotmentCancelledReq(allotmentPaymentId) {
    const { data, error } = await supabase
        .from("CancelUnitRequests")
        .select("*")
        .eq("allotmentPaymentId", allotmentPaymentId)
        .order("last_updated_at", { ascending: false });

    if (data) return data;
    else throw error;
}


export {
    getSpecificEvents, getAllotedData, changeAllotedUnit, getPendingChangeUnitRequestsByAllotment,
    checkForChangeUnitStatus, cancelAllotedUnit, checkForCancelUnitRequest,
    updateAllotmentPaymentStatus, getDataFromInventory, getAllotedDataInChangeUnit, getAllotedDataInAlotExistingUnit, getFirstPaymentDate,
    getAllotmentCancelledReq
}